import { UserAuthService, AuthenticationError } from '../services/auth/auth_user.service'
import { TokenService } from '../services/auth/token.service'
import { router } from '@/modules/router'
import { store } from '@/modules/store/store-module'
import axios from 'axios'

import { UserService } from '@/modules/partners/services/user.service'
import { User } from '@/modules/core/models'
import { ApiService } from '@/modules/core/services/api'
import { Dictionary } from 'vue-router/types/router'
// TODO not use still but it has to at some short point
// https://medium.com/@zitko/structuring-a-vue-project-authentication-87032e5bfe16

const state = {
  authenticating: false,
  accessToken: TokenService.getToken(),
  authenticationErrorCode: 0,
  authenticationError: '',
  refreshTokenPromise: null // Holds the promise of the refresh token
}

const getters = {
  loggedIn: () => {
    return !!state.accessToken
  },

  authenticationErrorCode: (state) => {
    return state.authenticationErrorCode
  },

  authenticationError: (state) => {
    return state.authenticationError
  },

  authenticating: (state) => {
    return state.authenticating
  }
}

const actions = {
  async login ({ state, commit, rootState }, { email, password }) {
    commit('loginRequest')

    try {
      const token = await UserAuthService.login(email, password)
      // let user:User = await UserService.get_current_user() TODO uncomment once user profile and user login is done
      // commit('setLoginUser', user, { root: true }) TODO uncomment once user profile and user login is done
      commit('loginSuccess', token)

      // Redirect the user to the page he first tried to visit or to the home view
      // router.push(router.history.current.query.redirect || '/');
      // router.history is not build in, but the idea is good, take as reference :
      // https://stackoverflow.com/questions/43714773/how-can-i-get-the-vue-routers-history
      router.push('/')

      return true
    } catch (e) {
      if (e instanceof AuthenticationError) {
        await store.dispatch('snackbar/activate',
          { message: 'El usuario o la contraseña introducida son incorrectas', code: 1 })
        commit('loginError', { errorCode: e.errorCode, errorMessage: e.message })
      }
      return false
    }
  },

  refreshToken ({ commit, state }) {
    // If this is the first time the refreshToken has been called, make a request
    // otherwise return the same promise to the caller
    if (!state.refreshTokenPromise) {
      const p = UserAuthService.refreshToken()
      commit('refreshTokenPromise', p)

      // Wait for the UserService.refreshToken() to resolve. On success set the token and clear promise
      // Clear the promise on error as well.
      p.then(
        response => {
          commit('refreshTokenPromise', null)
          commit('loginSuccess', response)
        },
        error => {
          commit('refreshTokenPromise', null)
        }
      )
    }

    return state.refreshTokenPromise
  },

  logout ({ commit }) {
    state.accessToken = null
    UserAuthService.logout()
    commit('refreshTokenPromise', null)
    commit('logoutSuccess')
    router.push('/')
  },

  async convert_social_token ({ commit }, socialTokenData) {
    console.warn(socialTokenData)
    try {
      commit('loginRequest')

      console.log(socialTokenData)

      fetch('http://localhost:8000/api/auth/convert_social_token/',
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': `Token ${socialTokenData.data.token}`,
            'Accept': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify({
            'grant_type': 'convert_token',
            'client_id': process.env.VUE_APP_APPLICATION_CLIENT_ID,
            'client_secret': process.env.VUE_APP_APPLICATION_SECRET,
            'backend': 'linkedin-oauth2'
          })
        })
        .then(async function (res) {
          let responseData = await res.json()
          console.log(responseData)
          TokenService.saveRefreshToken(responseData.refresh_token)
          commit('loginSuccess', responseData.access_token)
          router.push('/chat')
        })
        .catch(function (res) { console.error(res) })

      /*
      let socialData = JSON.parse(socialTokenData.data)

      fetch('http://localhost:8000/api/auth/convert-token/',
        {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/x-www-form-urlencoded',
            'Accept': 'application/json'
          },
          method: 'POST',
          body: JSON.stringify({
            'grant_type': 'convert_token',
            'client_id': process.env.VUE_APP_APPLICATION_CLIENT_ID,
            'client_secret': process.env.VUE_APP_APPLICATION_SECRET,
            'backend': 'linkedin-oauth2',
            'token': socialData.code
          })
        })
        .then(async function (res) {
          let token = await res.json()
          commit('loginSuccess', token)
        })
        .catch(function (res) { console.error(res) }) */

      // router.push('/chat')
    } catch (e) {
      if (e instanceof AuthenticationError) {
        await store.dispatch('snackbar/activate',
          { message: 'El usuario o la contraseña introducida son incorrectas', code: 1 })
        commit('loginError', { errorCode: e.errorCode, errorMessage: e.message })
      }
      return false
    }
  }
}

const mutations = {
  loginRequest (state) {
    state.authenticating = true
    state.authenticationError = ''
    state.authenticationErrorCode = 0
  },

  loginSuccess (state, accessToken) {
    state.accessToken = accessToken

    TokenService.saveToken(accessToken)

    state.authenticating = false
  },

  loginError (state, { errorCode, errorMessage }) {
    state.authenticating = false
    state.authenticationErrorCode = errorCode
    state.authenticationError = errorMessage
  },

  logoutSuccess (state) {
    state.accessToken = ''
    TokenService.removeToken()
  },
  refreshTokenPromise (state, promise) {
    state.refreshTokenPromise = promise
  }
}

export const AuthStore = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
